




























































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import PageTitle from '@/components/common/PageTitle.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {ncpPopup} from '@/utils/ncp';
import ItemTable from '@/components/common/ItemTable.vue';
import {getToday, addMonth} from '@/utils/dateUtils';
import {Mall} from 'supporter';
import {i18nInObjectList} from '@/utils/i18n';

@Component({
  components: {
    PageTitle,
    PeriodDateCalendar,
    ItemTable
  }
})
export default class CsList extends Vue {
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private adminNo: number = this.$store.getters['admin/admin'].no;
  private adminRole: string = this.$store.getters['admin/admin'].role;
  private adminName: string = this.$store.getters['admin/admin'].name;
  private searchType: any[] = [
    {
      value: 'ALL',
      label: 'CLAIM_CS_LIST_SELECT_ALL'
    },
    {
      value: 'ORDER_NO',
      label: 'CLAIM_CS_LIST_SEARCH_TYPE_ORDER_NO'
    },
    {
      value: 'ORDERER_NAME',
      label: 'CLAIM_CS_LIST_SEARCH_TYPE_ORDERER_NAME'
    },
    {
      value: 'ORDERER_CONTACT1',
      label: 'CLAIM_CS_LIST_SEARCH_TYPE_ORDERER_CONTACT1'
    },
    {
      value: 'REGISTER_NAME',
      label: 'CLAIM_CS_LIST_SEARCH_TYPE_REGISTER_NAME'
    },
    {
      value: 'UPDATE_ADMIN_NAME',
      label: 'CLAIM_CS_LIST_SEARCH_TYPE_UPDATE_ADMIN_NAME'
    }
  ];
  private csStatusType: any[] = [
    {
      value: 'PROCESSING',
      label: 'CLAIM_CS_LIST_CSSTATUS_TYPE_PROCESSING'
    },
    {
      value: 'DONE',
      label: 'CLAIM_CS_LIST_CSSTATUS_TYPE_DONE'
    }
  ];
  private csType: any[] = [
    {
      value: 'PAY',
      label: 'CLAIM_CS_LIST_CS_TYPE_PAY'
    },
    {
      value: 'PRODUCT',
      label: 'CLAIM_CS_LIST_CS_TYPE_PRODUCT'
    },
    {
      value: 'DELIVERY',
      label: 'CLAIM_CS_LIST_CS_TYPE_DELIVERY'
    },
    {
      value: 'CLAIM',
      label: 'CLAIM_CS_LIST_CS_TYPE_CLAIM'
    },
    {
      value: 'REFUND',
      label: 'CLAIM_CS_LIST_CS_TYPE_REFUND'
    },
    {
      value: 'ETC',
      label: 'CLAIM_CS_LIST_CS_TYPE_ETC'
    }
  ];
  private csPathType: any[] = [
    {
      value: 'IN_BOUND',
      label: 'CLAIM_CS_LIST_CS_PATH_TYPE_IN_BOUND'
    },
    {
      value: 'OUT_BOUND',
      label: 'CLAIM_CS_LIST_CS_PATH_TYPE_OUT_BOUND'
    },
    {
      value: 'ETC',
      label: 'CLAIM_CS_LIST_CS_PATH_TYPE_ETC'
    }
    // {
    //   value: 'SYSTEM',
    //   label: 'CLAIM_CS_LIST_CS_PATH_TYPE_SYSTEM'
    // }
  ];
  private theData: any[] = [];
  private topTotalCount: number = 0;
  private topTotalAdminCount: number = 0;
  private page: number = 1;
  private theForm = {
    mallNos: '0',
    searchType: 'ALL',
    keyword: '',
    csStatusTypes: '',
    csTypes: ['PAY', 'PRODUCT', 'DELIVERY', 'CLAIM', 'REFUND', 'ETC'],
    csPathType: ''
  };
  private tableOptions: any = {
    haveExcelDownBtn: false,
    haveConfigBtn: true,
    gridName: 'CS_GRID',
    pageSize: 30
  };
  private checkAllCsTypes: boolean = true;

  private startYmdt: string = addMonth(new Date(), -3);
  private endYmdt: string = getToday();

  @Watch('theForm.csTypes')
  csTypesChange() {
    if (this.theForm.csTypes.length === 6) {
      this.checkAllCsTypes = true;
    } else {
      this.checkAllCsTypes = false;
    }
  }
  checkAllChange() {
    if (this.checkAllCsTypes) {
      this.theForm.csTypes = ['PAY', 'PRODUCT', 'DELIVERY', 'CLAIM', 'REFUND', 'ETC'];
    } else {
      this.theForm.csTypes = [];
    }
  }
  private gridProps = {
    options: {
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        centerAlign: true
      },
      rowHeaders: ['checkbox']
    },

    columns: [
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_ONE',
        name: 'csStatusType',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => {
          let theOpt = '';
          let theSelect = '';
          let content = '';
          this.csStatusType.map((dct: any): any => {
            if (data.value === dct.value) {
              theOpt += `<option selected value="${dct.value}">${window.$t(dct.label)}</option>`;
            } else {
              theOpt += `<option value="${dct.value}">${window.$t(dct.label)}</option>`;
            }
          });
          if (data.row.adminNo !== this.adminNo && this.adminRole === 'NORMAL') {
            theSelect = `<select name="2" style="width: 100%;" disabled>${theOpt}</select>`;
          } else {
            theSelect = `<select name="2" style="width: 100%;">${theOpt}</select>`;
          }
          content = `<span class="tui-grid-content-before"></span><span class="tui-grid-content-after"></span><span class="tui-grid-content-input">${theSelect}</span>`;
          return `${content}`;
        }
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_TWO',
        name: 'mallName',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_THREE',
        name: 'registerYmdt',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_FOUR',
        align: 'center',
        minWidth: 150,
        name: 'orderNo',
        formatter: (data: any) => `<a href="/order/detail?orderNo=${data.value}" target="_blank">${data.value}</a>`
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_FIVE',
        align: 'center',
        minWidth: 80,
        name: 'ordererName',
        formatter: (data: any) => {
          const memberNo = data.row.memberNo || 0;
          return memberNo === 0 ? data.value : `<a href="javascript:;" class="ordererPopup" data-memberno="${memberNo}">${data.value}</a>`;
        }
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_SIX',
        align: 'center',
        minWidth: 100,
        name: 'ordererContact1'
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_SEVEN',
        name: 'csType',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => {
          let theOpt = '';
          let theSelect = '';
          let content = '';
          this.csType.map((dct: any): any => {
            if (data.value === dct.value) {
              theOpt += `<option selected value="${dct.value}">${window.$t(dct.label)}</option>`;
            } else {
              theOpt += `<option value="${dct.value}">${window.$t(dct.label)}</option>`;
            }
          });
          if (data.row.adminNo !== this.adminNo && this.adminRole === 'NORMAL') {
            theSelect = `<select name="3" style="width: 100%;" disabled>${theOpt}</select>`;
          } else {
            theSelect = `<select name="3" style="width: 100%;">${theOpt}</select>`;
          }
          content = `<span class="tui-grid-content-before"></span><span class="tui-grid-content-after"></span><span class="tui-grid-content-input">${theSelect}</span>`;
          return `${content}`;
        }
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_EIGHT',
        name: 'content',
        align: 'left',
        minWidth: 160
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_NINE',
        name: 'csPathTypeName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_TEN',
        name: 'registerName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_ELEVEN',
        name: 'updateAdminName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'CLAIM_CS_LIST_TABLE_HEADER_TWELVE',
        name: 'deleteBtn',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => (data.row.adminNo === this.adminNo || this.adminRole === 'MASTER' ? `<button type="button" class="deleteBtn" data-cs-no="${data.row.csNo}">삭제</button>` : '')
      }
      // {
      //   header: 'CLAIM_CS_LIST_TABLE_HEADER_THIRTEEN',
      //   name: 'adminNo',
      //   hidden: true
      // }
    ]
  };
  private getTotalCountByAdmin() {
    let obj = {
      params: {
        startYmdt: addMonth(new Date(), -12) + ' 00:00:00',
        endYmdt: getToday() + ' 23:59:59'
      }
    };
    this.$api.getCsAdminSummary(obj).then((res: any) => {
      this.topTotalCount = res.data.totalProcessingCount;
      this.topTotalAdminCount = res.data.myProcessingCount;
    });
  }

  private deleteCs(e: any) {
    const type = e || '';
    const deleteCs = () => {
      if (!window.confirm(this.$t('CLAIM_CS_LIST_DELETE_CONFIRM') as any)) {
        return;
      }
      let csNos: any[] = [];
      if (type === 'all') {
        csNos = csNos.concat((this.$refs.theGrid as any).getCheckedRows().map((row: any) => row.csNo));
      } else {
        csNos = csNos.concat($(e.target).data('csNo'));
      }
      const obj: any = {
        params: {
          csNos: csNos.join(',')
        }
      };
      this.$api.deleteCsAdmin(obj).then(() => {
        this.search();
      });
    };
    if (type === 'all') {
      if (this.validateCheckRows()) {
        deleteCs();
      }
    } else {
      deleteCs();
    }
  }
  private validateCheckRows() {
    if ((this.$refs.theGrid as any).getCheckedRowKeys().length === 0) {
      window.alert(this.$t('CLAIM_CS_LIST_CHECKROWS_ERROR'));
      return false;
    }
    return true;
  }

  private search(page?: number, size?: number) {
    if (this.theForm.csTypes.length === 0) {
      alert(this.$t('CLAIM_CS_LIST_CS_TYPE_LENGTH_ERROR'));
      return;
    }

    let obj: any = {
      params: {
        csPathType: this.theForm.csPathType,
        csStatusTypes: this.theForm.csStatusTypes,
        csTypes: this.theForm.csTypes.join(','),
        keyword: this.theForm.keyword,
        mallNos: this.theForm.mallNos,
        page: page ? page : this.page,
        searchType: this.theForm.searchType,
        showsOnlyMine: null,
        size: size ? size : (this.$refs.theGrid as any).itemInfo.pageSize,
        endYmdt: this.endYmdt + ' 23:59:59',
        startYmdt: this.startYmdt + ' 00:00:00'
      }
    };
    // 전체(all) 的情况
    if (this.theForm.mallNos === '0') {
      obj.params.mallNos = this.malls.map((v) => v.mallNo).join(',');
    }
    this.$api.getCsAdmin(obj).then((res: any) => {
      res.data.contents.map((item: any) => {
        Vue.set(item, 'csPathTypeName', this.$t(this.csPathType.filter((temp) => temp.value === item.csPathType)[0].label));
      });
      this.theData = [...res.data.contents];
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.perPage = obj.params.size;
      this.gridProps.options.pageOptions.page = obj.params.page;
      this.$nextTick(() => {
        this.checkGridSelectBoxAdminNo();
        this.getTotalCountByAdmin();
      });
    });
  }
  private resetAll() {
    this.theForm = {
      mallNos: '0',
      searchType: 'ALL',
      keyword: '',
      csStatusTypes: '',
      csTypes: ['PAY', 'PRODUCT', 'DELIVERY', 'CLAIM', 'REFUND', 'ETC'],
      csPathType: ''
    };
    let tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('3m');
  }
  private checkGridSelectBoxAdminNo() {
    (this.$refs.theGrid as any).getData().forEach((row: any) => {
      if (row.adminNo !== this.adminNo && this.adminRole === 'NORMAL') {
        (this.$refs.theGrid as any).disableRowCheck(row.rowKey);
      }
    });
  }
  private clickPopup(e: any) {
    if (this.validateCheckRows()) {
      const type = e;
      const csNos = (this.$refs.theGrid as any).getCheckedItems('csNo');
      sessionStorage.setItem('csNos', csNos);
      (window as any).csListSearch = this.csListSearch;
      ncpPopup(`/claim/cs/modifyPopup?type=${type}`, 'csModifyPopup', 720, 375);
    }
  }
  private csListSearch() {
    this.search();
    sessionStorage.removeItem('csNos');
  }
  private clickOrdererPopup(e: any) {
    const memberNo = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberNo}`, '회원정보', 1100, 980);
  }
  private clickSearchTotalCount() {
    this.setTotalCountCondition();
    this.theForm.searchType = 'ALL';
    this.theForm.keyword = '';
    this.$nextTick(() => {
      this.search();
    })
  }
  private clickSearchTotalCountByAdmin() {
    this.setTotalCountCondition();
    this.theForm.searchType = 'REGISTER_NAME';
    this.theForm.keyword = this.adminName;
    this.search();
  }
  private setTotalCountCondition() {
    this.page = 1;
    this.theForm.mallNos = '0';
    this.theForm.csStatusTypes = 'PROCESSING';
    let tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('1y');
    this.theForm.csTypes = ['PAY', 'PRODUCT', 'DELIVERY', 'CLAIM', 'REFUND', 'ETC'];
    this.theForm.csPathType = '';
  }
  private changeCsType(e: any) {
    const rowKey = $(e.target).parents('td').data('rowKey');
    let obj: any = {
      data: {
        csNos: [(this.$refs.theGrid as any).getRow(rowKey).csNo],
        csType: $(e.target).val()
      }
    };

    this.$api.putCsAdminBulk(obj).then(() => {
      window.alert(this.$t('CLAIM_CS_LIST_CHANGE_SUCCESS'));
    });
  }
  private changeCsStatusType(e: any) {
    const rowKey = $(e.target).parents('td').data('rowKey');
    let obj: any = {
      data: {
        csNos: [(this.$refs.theGrid as any).getRow(rowKey).csNo],
        csStatusType: $(e.target).val()
      }
    };

    this.$api.putCsAdminBulk(obj).then(() => {
      window.alert(this.$t('CLAIM_CS_LIST_CHANGE_SUCCESS'));
      this.getTotalCountByAdmin();
    });
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    if (this.malls.length === 1) {
      this.theForm.mallNos = this.malls[0].mallNo + '';
    }
  }
  private mounted(): void {
    this.getTotalCountByAdmin();
    $('body').on('change', '[data-column-name="csStatusType"]', $.proxy(this.changeCsStatusType, this));
    $('body').on('change', '[data-column-name="csType"]', $.proxy(this.changeCsType, this));
    $('body').on('click', '.deleteBtn', $.proxy(this.deleteCs, this));
    $('body').on('click', '.ordererPopup', $.proxy(this.clickOrdererPopup, this));
  }
  private destroyed(): void {
    $('body').off('change', '[data-column-name="csStatusType"]', $.proxy(this.changeCsStatusType, this));
    $('body').off('change', '[data-column-name="csType"]', $.proxy(this.changeCsType, this));
    $('body').off('click', '.deleteBtn', $.proxy(this.deleteCs, this));
    $('body').off('click', '.ordererPopup', $.proxy(this.clickOrdererPopup, this));
  }
}
